import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { LoggingService } from '../../../shared/services/core/logging.service';
import { PopUpNotificationService } from './popup-notification.service';

@Injectable({ providedIn: 'root' })
export class PopUpNotificationResolver  {
    constructor(private popUpNotificationService: PopUpNotificationService,private logService: LoggingService) {}
/**
   * Resolve the current user's popup notifications
   * @param route Route data/params
   * @param state State of the router
   */
    resolve(): Observable<null> | Observable<Observable<null>> | Promise<Observable<null>> {
        this.logService.info(`Resolving popup Notifications`);
        return this.popUpNotificationService.fetchPopUpNotifications();
    }
}